module.exports = __webpack_public_path__ + "static/media/agendaBG.8a96e5f5.jpg";